import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { z } from 'zod';

import { defaultApi } from '../clients.js';
import { CampaignSchema } from './schemas/CampaignSchema.js';
import { CampaignTitleSchema } from './schemas/CampaignTitleSchema.js';

export const getCampaign = defaultApi.declareEndpoint({
  url: 'datintell/v1/campaign_collections/$campaignId/' as const,
  method: 'GET',
  responseSchema: CampaignSchema,
});

export type CampaignType = z.infer<typeof CampaignSchema>;

export const getCampaignQueryOptions = makeQueryOptions(getCampaign, {
  processResponse(data) {
    return data;
  },
});

export const getCampaignTitle = defaultApi.declareEndpoint({
  url: 'datintell/v1/campaign_collections/$campaignId/title/' as const,
  method: 'GET',
  responseSchema: CampaignTitleSchema,
});

export type CampaignTitleType = z.infer<typeof CampaignTitleSchema>;

export const getCampaignTitleQueryOptions = makeQueryOptions(getCampaignTitle, {
  processResponse(data) {
    return data;
  },
});
